module.exports = __webpack_public_path__ + "static/media/washington-dc-17.760f30d3.jpg";